import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Grid,
  Container,
  Pagination,
  Card,
  CardContent,
  Typography,
  Box,
} from "@mui/material";
import Moment from "react-moment";
import axios from "axios";

import Loading from "./Loading";
import PostMediaCard from "./PostMediaCard";

const PostsViews = (props) => {
  const { urlProp = "", showPagination = true } = props;
  const [mrData, setMrData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [headerInfo, setHeaderInfo] = useState({});
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    const params = new URLSearchParams(urlProp);
    if (!params.has("per_page")) {
      params.set("per_page", "9");
    }
    params.set("page", String(pageNumber));
    params.set("_embed", "true");

    const url = `https://www.mrapi.mruns.com/wp-json/wp/v2/posts?${params.toString()}`;
    axios
      .get(url)
      .then((response) => {
        setMrData(response.data);
        setHeaderInfo(response.headers);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  }, [pageNumber, urlProp]);

  const handlePageChange = (event, page) => {
    setPageNumber(page);
  };

  return (
    <Container sx={{ py: 2 }} maxWidth="lg">
      {loading && <Loading />}
      <Grid container spacing={4}>
        {mrData.map((data) => {
          const imageUrl = data._embedded?.['wp:featuredmedia']?.[0]?.source_url;

          return (
            <Grid item key={data.id} xs={12} sm={6} md={4}>
              <Link to={`/detail/${data.slug}`} state={{ postData: data }} style={{ textDecoration: 'none' }}>
                <Card sx={{ 
                  height: '100%', 
                  display: 'flex', 
                  flexDirection: 'column',
                  transition: 'transform 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'scale(1.03)'
                  }
                }}>
                  <PostMediaCard imageUrl={imageUrl} />
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography gutterBottom variant="h5" component="h2" sx={{ fontWeight: 'bold' }}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: data.title.rendered,
                        }}
                      />
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <Moment format="MMMM Do, YYYY">{data.date}</Moment>
                    </Typography>
                  </CardContent>
                </Card>
              </Link>
            </Grid>
          );
        })}
      </Grid>
      {showPagination && !loading && headerInfo["x-wp-totalpages"] > 1 && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <Pagination
            count={parseInt(headerInfo["x-wp-totalpages"])}
            variant="outlined"
            color="primary"
            onChange={handlePageChange}
          />
        </Box>
      )}
    </Container>
  );
};

export default PostsViews;
